import React, {useEffect, useRef, useState} from "react";
import {TextField, RadioGroup} from "formik-material-ui";
import {
    Typography,
    Grid,
    Select,
    MenuItem,
    FormControlLabel,
    Radio,
    useMediaQuery,
    CircularProgress,
    TextField as RTextField,
    makeStyles,
    Breadcrumbs,
    RadioGroup as RadioGroupMUI
} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import {Link} from "react-router-dom";
import {useSnackbar} from "notistack";
import {useParams, useHistory, useLocation} from "react-router-dom";
import Box from "@material-ui/core/Box";
import {Formik, Form, Field, FormikProps, ErrorMessage} from "formik";
import * as Yup from "yup";
import {IPetFormFields, medicine, petSex} from "../../../../interfaces";
import {ReactComponent as LogoSVG} from "../../../../Images/logo.svg";
import {ReactComponent as PencilSVG} from "../../../../Images/pencil.svg";
import UploadPhoto from "../../../Modals/UploadPhoto";
import {useTheme} from "@material-ui/core/styles";
import {colorBorder, colorError, colorInputBorderGrayish} from "../../../../Constants/theme";
import {createPetTypeIconLookup} from "../../../../utils/petTypeIcons";
import {dogs} from "../../../../Constants/dogs";
import {cats} from "../../../../Constants/cats";
import {birds} from "../../../../Constants/birds";
import {amphibians} from "../../../../Constants/amphibians";
import {aquatic} from "../../../../Constants/aquatic";
import {rodent} from "../../../../Constants/rodent";
import {mustelidae} from "../../../../Constants/mustelodae";
import {useSelector} from "react-redux";
import {RootState, useAppDispatch} from "../../../../redux/store";
import {editAnimal, getPetURLUploadImage, setAnimal} from "../../../../redux/pets/pets.actions";
import {specialities, petTypes as hrPetTypes, rhapsodyPetTypes} from "../../../../Constants/specialities";
import {Autocomplete} from "@material-ui/lab";
import {setPetType} from "../../../../utils/petInfo";
import {
    BASIC_PET_TYPE_OPTIONS,
    getBasicTypeSelection,
    getOtherPetTypes,
    isBasicPetType,
    PetTypeOption,
} from "../../../../utils/petTypeOptions";
import {DatePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import {generalColors, dogsAndCatsColors} from "../../../../Constants/colors";
import {insurances, insuranceList} from "../../../../Constants/insurance";
import {diets, dietTypes} from "../../../../Constants/diets";
import moment from "moment";
import {ReactComponent as AddPetSVG} from "../../../../Images/addPetIcon.svg";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";

const initialValues: IPetFormFields["general"] = {
    name: "",
    type: "",
    breed: "",
    dateOfBirth: null,
    weight: null,
    sex: "",
    diet: [],
    neuteredSpayed: "",
    primaryColor: "",
    secondaryColor: "",
    insuranceProvider: "",
    otherInsuranceProvider: "",
    primaryVetName: "",
    primaryVetPhoneNumber: "",
    environment: "",
    numLitterBoxes: "",
    clinicEmail: "",
    pharmacyName: "",
    pharmacyPhone: "",
    medications: [],
};

interface Props {
    isOnBoarding: boolean;
    setIsOnBoarding: React.Dispatch<React.SetStateAction<boolean>>;
    id?: { petId: string };
    disabled: boolean;
}

const useStyle = makeStyles(() => ({
    itemContainer: {
        marginBottom: "25px"
    },
    formError: {
        color: colorError,
        fontSize: "12px",
        marginLeft: "14px",
        marginTop: "4px"
    },
    inputLabel: {
        "&.focused": {
            color: "#aaa"
        },
        "&.shrink": {
            color: "#aaa"
        }
    }
}));
const usePlaceholderStyles = makeStyles(theme => ({
    placeholder: {
        color: "#aaa"
    }
}));

const Placeholder = ({ children }) => {
    const classes = usePlaceholderStyles();
    return <div className={classes.placeholder}>{children}</div>;
};

export default ({isOnBoarding, setIsOnBoarding, disabled, id}: Props) => {
    const [formikValues, setFormikValues] = useState<IPetFormFields["general"]>(initialValues);
    const [isMainInfoPulled, setIsMainInfoPulled] = useState(false);
    const [uploadPhotoModalVisibility, setUploadPhotoModalVisibility] = useState(false);
    const [uploadPhotoURL, setUploadPhotoUrl] = useState("");
    const [linkToImage, setLinkToImage] = useState("");
    const classes = useStyle();
    const [animalType, setAnimalType] = useState("Other");
    const [allergies, setAllergies] = useState("");
    const [chronicIllnesses, setChronicIllnesses] = useState("");
    const validationSchema = Yup.object().shape({
        name: Yup.string().required("Required"),
        type: Yup.string().required("Required"),
        dateOfBirth: Yup.string().min(2).typeError("Required").required("Required"),
        weight: Yup.number().typeError("Required").required("Required"),
        sex: Yup.string().required("Required"),
        neuteredSpayed: Yup.boolean().required("Required"),
        clinicEmail: Yup.string().email("Invalid email"),
        breed: Yup.string().nullable().required("Required"),
        primaryColor: Yup.string().required("Required"),
    });
    const {enqueueSnackbar} = useSnackbar();
    let history = useHistory();
    const location = useLocation<{ returnTo?: string }>();
    let {petId} = id.petId != "0" ? id : useParams<{ petId: string }>();
    const theme = useTheme();
    const pet = useSelector((state: RootState) => state?.pets.selectedPet);
    const clinicId = useSelector((state: RootState) => state?.branding.clinicId);
    const clinicName = useSelector((state: RootState) => state?.branding.name);
    const partnerType = useSelector((state: RootState) => state?.branding.type);
    const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
    const dispatch = useAppDispatch();
    const user = useSelector((state: RootState) => state?.user);
    const setType = (type: PetTypeOption) => {
        const petType = setPetType(type.value);
        setAnimalType(petType);
    };
    const branding = useSelector((state: RootState) => state?.branding);
    const isWhiteLabel = useSelector((state: RootState) => state?.branding.partnerPreferencesOn);
    const [pcv, setPCV] = useState(clinicName ? "yes" : "no");
    const [clinic, setClinic] = useState(clinicName);
    const [pcvPhone, setPCVPhone] = useState("");
    const [isSubmit, setIsSubmit] = useState(false);
    const [isType, setIsType] = useState(false);
    const [isBirthday, setIsBirthday] = useState(false);
    const [isBreed, setIsBreed] = useState(false);
    const [isPrimaryColor, setIsPrimaryColor] = useState(false);
    const petTypes: PetTypeOption[] = clinicId ? rhapsodyPetTypes : hrPetTypes;
    const otherPetTypes = getOtherPetTypes(petTypes);
    const [isOtherTypeSelected, setIsOtherTypeSelected] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (petId) {
            if (petId === "0") {
                setIsMainInfoPulled(true);
                return;
            }
            setLinkToImage(pet.imageUrl);
            const allergiesList = pet.allergies.map((allergy) => {
                return allergy.name;
            }, 0);
            setAllergies(allergiesList.join(", "));
            const chronicList = pet.chronicConditions.map((illness) => {
                return illness.name;
            }, 0);
            setChronicIllnesses(chronicList.join(", "));
            const dietsList = pet?.diet && pet.diet.map((currValue) => dietTypes.find(({value}) => currValue === value)?.type);
            const resolvedType = (() => {
                const petType = pet.type === "Other" ? pet.breed : pet.type;
                const reg = new RegExp(petType, "i");
                let type = "Other";
                petTypes.forEach(item => {
                    if (reg.test(item.value)) {
                        type = item.value;
                    }
                });
                return type;
            })();
            setIsOtherTypeSelected(!isBasicPetType(resolvedType));
            const initialValues = {
                name: pet.name,
                type: resolvedType,
                breed: pet.breed || "",
                diet: dietsList || [],
                weight: pet.weight || 0,
                sex: petId !== "0" ? pet.sex as petSex : "",
                dateOfBirth: pet.dateOfBirth || null,
                neuteredSpayed: pet.neuteredSpayed && "true" || "false",
                primaryColor: Object.prototype.hasOwnProperty.call(pet, "primaryColor") ? pet["primaryColor"][0] === undefined ? "" : pet["primaryColor"][0] + pet["primaryColor"].slice(1).toLowerCase() : "",
                secondaryColor: Object.prototype.hasOwnProperty.call(pet, "secondaryColor") ? pet["secondaryColor"][0] === undefined ? "" : pet["secondaryColor"][0] + pet["secondaryColor"].slice(1).toLowerCase() : "",
                insuranceProvider: Object.prototype.hasOwnProperty.call(pet, "insuranceProvider") ? insurances.filter(item => item.value === pet["insuranceProvider"])[0].label : "",
                otherInsuranceProvider: Object.prototype.hasOwnProperty.call(pet, "otherInsuranceProvider") ? pet["otherInsuranceProvider"] : "",
                primaryVetName: Object.prototype.hasOwnProperty.call(pet, "primaryVetName") ? pet["primaryVetName"] : "",
                primaryVetPhoneNumber: Object.prototype.hasOwnProperty.call(pet, "primaryVetPhoneNumber") ? pet["primaryVetPhoneNumber"] : "",
                clinicEmail: pet?.clinicEmail ? pet.clinicEmail : "",
                pharmacyName: pet?.pharmacyName || "",
                pharmacyPhone: pet?.pharmacyPhone || "",
                medications: pet?.medications,
            };
            if (pet?.type === "FELINE") {
                initialValues["environment"] = pet.environment;
                initialValues["numLitterBoxes"] = pet.numLitterBoxes;
            }
            //@ts-ignore
            setFormikValues(initialValues);
            setAnimalType(setPetType(resolvedType));
            if (Object.prototype.hasOwnProperty.call(pet, "primaryVetName")) {
                setClinic(pet["primaryVetName"] || clinicName);
                if (pet["primaryVetName"] !== "" || clinicName.length) {
                    setPCV("yes");
                } else {
                    setPCV("no");
                }
            }
            if (Object.prototype.hasOwnProperty.call(pet, "primaryVetPhoneNumber")) {
                setPCVPhone(pet["primaryVetPhoneNumber"]);
            }
            if (!disabled) {
                dispatch(getPetURLUploadImage(pet.id))
                    .then((res) => {
                        setUploadPhotoUrl(res.uploadUrl);
                    });
            }
            setIsMainInfoPulled(true);
        }
    }, []);

    const handlePCVChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setPCV((event.target as HTMLInputElement).value);
    };

    return (
        <Formik
            initialValues={formikValues}
            enableReinitialize
            onSubmit={async (values, {setStatus}) => {
                let neuteredSpayed;
                if (values.neuteredSpayed === "true") {
                    neuteredSpayed = true;
                } else {
                    neuteredSpayed = false;
                }
                try {
                    setIsMainInfoPulled(false);
                    const petName = values.name.charAt(0).toUpperCase() + values.name.slice(1).toLowerCase();
                    const primary = values.primaryColor ? values.primaryColor.toUpperCase() : "";
                    const secondary = values.secondaryColor ? values.secondaryColor.toUpperCase() : "";
                    const userInsurance = values.insuranceProvider !== "" ? insurances.filter(item => item.label === values.insuranceProvider)[0].value : null;
                    const otherInsurance = values.otherInsuranceProvider !== "" ? values.otherInsuranceProvider : "";
                    const dietsList = values.diet.map((currType) => dietTypes.find(({type}) => currType === type)?.value);
                    const body = {
                        ownerId: user.userId,
                        type: values.type,
                        name: petName,
                        breed: values.breed,
                        dateOfBirth: values.dateOfBirth,
                        weight: values.weight,
                        sex: values.sex,
                        diet: dietsList,
                        neuteredSpayed: neuteredSpayed,
                        primaryColor: primary,
                        secondaryColor: secondary,
                        insuranceProvider: userInsurance,
                        otherInsuranceProvider: otherInsurance,
                        clinicEmail: values.clinicEmail,
                    };
                    if (animalType === "Cat") {
                        body["environment"] = values?.environment ? values?.environment : "";
                        body["numLitterBoxes"] = values?.numLitterBoxes ? values?.numLitterBoxes : "";
                    }

                    if (pcv === "yes") {
                        body["primaryVetName"] = clinic;
                        body["primaryVetPhoneNumber"] = pcvPhone;
                    } else {
                        body["primaryVetName"] = "";
                        body["primaryVetPhoneNumber"] = "";
                    }

                    if (!!+petId) {
                        await dispatch(editAnimal(petId, body));
                    } else {
                        await dispatch(setAnimal(body));
                    }
                    setStatus({success: true});
                    enqueueSnackbar("The pet profile is updated");
                    setIsMainInfoPulled(true);
                    if (location.state?.returnTo) {
                        history.push(location.state.returnTo);
                    } else if (isOnBoarding) {
                        setIsOnBoarding(false);
                        document.cookie = "isOnBoarding= ; expires=Thu, 01 Jan 1970 00:00:00 UTC;";
                        history.push("/schedule");
                    }
                    else history.push("/pets");
                } catch (error) {
                    enqueueSnackbar(error.message || error.errorMessage, {
                        variant: "error",
                        autoHideDuration: 3000,
                    });
                    setStatus({success: false});
                    setIsMainInfoPulled(true);
                }
            }}
            validationSchema={validationSchema}
        >
            {
                ({
                    values,
                    handleChange,
                    handleBlur,
                    setFieldValue,
                    errors,
                    touched
                }: FormikProps<IPetFormFields["general"]>) => {
                    const imageRef = useRef(null);
                    const handleImageLoadError = () => {
                        setLinkToImage("");
                    };
                    // @ts-ignore
                    // @ts-ignore
                    // @ts-ignore
                    return (
                        <Form>
                            {
                                isMainInfoPulled ?
                                <>
                                { !disabled ? (
                                    <Box marginBottom="55px">
                                    <Breadcrumbs separator={<NavigateNextIcon fontSize="large"/>} aria-label="breadcrumb">
                                        {(!!+petId) && <Link color="inherit" to={`/pets/${petId}`}  style={{textDecoration: "none"}}>
                                            <Typography variant="h2">{pet.name}</Typography>
                                        </Link>}
                                        <Typography variant="h2" style={{wordBreak: "break-word"}}>General Information</Typography>
                                    </Breadcrumbs>
                                </Box>) :
                                (<Box marginBottom="55px">
                                    <Typography variant="h2">{pet.name}</Typography>
                                </Box>)
                                }
                                        <Box marginTop="32px" marginBottom="40px">
                                            <Grid container spacing={2}>
                                                <Grid xs={12} sm={3} item>
                                                    <Box position="relative" width="fit-content">
                                                        {
                                                            !disabled && !!+petId &&
                                                            <Box
                                                                position="absolute"
                                                                right="-10px"
                                                                bottom="-9px"
                                                                borderRadius="50%"
                                                                bgcolor={branding.brandAccent}
                                                                width="21px"
                                                                style={{cursor: "pointer"}}
                                                                height="21px"
                                                                display="flex"
                                                                justifyContent="center"
                                                                alignItems="center"
                                                                onClick={() => {
                                                                    setUploadPhotoModalVisibility(true);
                                                                }}
                                                            >
                                                                <PencilSVG/>
                                                            </Box>
                                                        }
                                                        {
                                                            linkToImage ?
                                                                <img
                                                                    alt="pet image"
                                                                    ref={imageRef}
                                                                    src={linkToImage}
                                                                    onError={handleImageLoadError}
                                                                    width="100"
                                                                    height="100"
                                                                    style={{objectFit: "cover"}}
                                                                />
                                                                :
                                                                !isWhiteLabel ?
                                                                    createPetTypeIconLookup()[animalType] ||
                                                                        <Box display="flex" justifyContent="center"
                                                                            alignItems="center" width="100px"
                                                                            height="100px">
                                                                            <AddPetSVG/>
                                                                        </Box>
                                                                    :
                                                                    <Box display="flex" justifyContent="center"
                                                                        alignItems="center" width="100px"
                                                                        height="100px">
                                                                        <img
                                                                            alt="brand logo"
                                                                            src={branding.logo}
                                                                            width="100%"
                                                                        />
                                                                    </Box>

                                                        }
                                                    </Box>
                                                </Grid>
                                                <Grid item container alignItems="flex-start" xs={12} sm={9} spacing={2}>
                                                    <Grid item xs={12} container justify="space-between"
                                                        alignItems="center">
                                                        <Grid item xs={4}>
                                                            <Typography variant="body2" style={{marginRight: "50px"}}>
                                                                Name
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={8}>
                                                            <Field
                                                                id="name"
                                                                label="Name"
                                                                aria-labelledby="name"
                                                                component={TextField}
                                                                name="name"
                                                                value={values.name}
                                                                variant="outlined"
                                                                color="secondary"
                                                                type="text"
                                                                margin="dense"
                                                                size="small"
                                                                fullWidth
                                                                onChange={handleChange}
                                                                placeholder=""
                                                                disabled={disabled}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                    <Grid item xs={12} container alignItems="center">
                                                        <Grid item xs={4}>
                                                            <Typography variant="body2">
                                                                Type of Pet
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={8}>
                                                            <Autocomplete<PetTypeOption, false, true, false>
                                                                id="species"
                                                                aria-labelledby="Type of Pet"
                                                                fullWidth
                                                                options={BASIC_PET_TYPE_OPTIONS}
                                                                disableClearable
                                                                getOptionLabel={(option) => option.label}
                                                                value={getBasicTypeSelection(values.type, isOtherTypeSelected)}
                                                                onChange={(event, value: PetTypeOption) => {
                                                                    if (value.value === "OTHER") {
                                                                        setIsOtherTypeSelected(true);
                                                                        setFieldValue("type", "");
                                                                        setFieldValue("breed", "");
                                                                        setAnimalType("Other");
                                                                        setIsType(false);
                                                                        return;
                                                                    }
                                                                    setIsOtherTypeSelected(false);
                                                                    setFieldValue("type", value.value);
                                                                    setFieldValue("breed", "");
                                                                    setType(value);
                                                                    setIsType(false);
                                                                }}
                                                                onBlur={() => {
                                                                    if (!getBasicTypeSelection(values.type, isOtherTypeSelected)) {
                                                                        setIsType(true);
                                                                    }
                                                                }}
                                                                disabled={disabled}
                                                                renderInput={(params) =>
                                                                    <>
                                                                        <RTextField {...params}
                                                                            error={!getBasicTypeSelection(values.type, isOtherTypeSelected) && (isType || isSubmit)}
                                                                            margin="dense"
                                                                            variant="outlined"
                                                                            label="Type of pet"
                                                                        />
                                                                        {!getBasicTypeSelection(values.type, isOtherTypeSelected) && (isType || isSubmit) && <Typography
                                                                            className={classes.formError}>Required</Typography>}
                                                                    </>}
                                                            />
                                                            {isOtherTypeSelected &&
                                                                <Box marginTop={1}>
                                                                    <Autocomplete<PetTypeOption, false, true, false>
                                                                        fullWidth
                                                                        options={otherPetTypes}
                                                                        disableClearable
                                                                        getOptionLabel={(option) => option.label}
                                                                        value={otherPetTypes.find(type => type.value === values.type) || null}
                                                                        onChange={(event, value: PetTypeOption) => {
                                                                            setFieldValue("type", value.value);
                                                                            setFieldValue("breed", "");
                                                                            setType(value);
                                                                            setIsType(false);
                                                                        }}
                                                                        onBlur={() => {
                                                                            if (!values.type.length) {
                                                                                setIsType(true);
                                                                            }
                                                                        }}
                                                                        disabled={disabled}
                                                                        renderInput={(params) =>
                                                                            <>
                                                                                <RTextField {...params}
                                                                                    error={!values.type && (isType || isSubmit)}
                                                                                    margin="dense"
                                                                                    variant="outlined"
                                                                                    label="Other type"
                                                                                />
                                                                                {!values.type && (isType || isSubmit) && <Typography
                                                                                    className={classes.formError}>Required</Typography>}
                                                                            </>}
                                                                    />
                                                                </Box>
                                                            }
                                                        </Grid>
                                                    </Grid>
                                                    <Grid item xs={12} container alignItems="center">
                                                        <Grid item xs={4}>
                                                            <Typography variant="body2">
                                                                Breed
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={8}>
                                                            {animalType === "CANINE" &&
                                                            <Autocomplete
                                                                fullWidth
                                                                id="breed"
                                                                aria-labelledby="breed"
                                                                options={dogs}
                                                                disableClearable
                                                                getOptionLabel={(option) => option}
                                                                value={values.breed}
                                                                onChange={(event, value) => {
                                                                    setFieldValue("breed", value);
                                                                    setIsBreed(false);
                                                                }}
                                                                onBlur={()=>{
                                                                    if (!values.breed.length) {
                                                                        setFieldValue("breed", "");
                                                                        setIsBreed(true);
                                                                    }
                                                                }}
                                                                disabled={disabled}
                                                                renderInput={(params) =>
                                                                    <>
                                                                        <RTextField {...params}
                                                                            error={(isSubmit || isBreed) && !values.breed}
                                                                            margin="dense"
                                                                            variant="outlined"
                                                                            label="Breed"
                                                                        />
                                                                        {(!values.breed && (isBreed || isSubmit)) && <Typography
                                                                            className={classes.formError}>Required</Typography>}
                                                                    </>
                                                                }
                                                            />
                                                            }
                                                            {animalType === "FELINE" &&
                                                            <Autocomplete
                                                                fullWidth
                                                                aria-labelledby="breed"
                                                                aria-label="breed"
                                                                options={cats}
                                                                disableClearable
                                                                getOptionLabel={(option) => option}
                                                                value={values.breed}
                                                                onChange={(event, value) => {
                                                                    setFieldValue("breed", value);
                                                                    setIsBreed(false);
                                                                }}
                                                                onBlur={()=>{
                                                                    if (!values.breed.length) {
                                                                        setFieldValue("breed", "");
                                                                        setIsBreed(true);
                                                                    }
                                                                }}
                                                                disabled={disabled}
                                                                renderInput={(params) => <>
                                                                    <RTextField {...params}
                                                                        error={(isSubmit || isBreed) && !values.breed}
                                                                        margin="dense"
                                                                        variant="outlined"
                                                                        label="Breed"
                                                                    />
                                                                    {(!values.breed && (isBreed || isSubmit)) && <Typography
                                                                        className={classes.formError}>Required</Typography>}
                                                                </>}
                                                            />
                                                            }
                                                            {animalType === "AVIAN" &&
                                                            <Autocomplete
                                                                fullWidth
                                                                id="breed"
                                                                aria-labelledby="breed"
                                                                options={birds}
                                                                disableClearable
                                                                getOptionLabel={(option) => option}
                                                                value={values.breed}
                                                                onChange={(event, value) => {
                                                                    setFieldValue("breed", value);
                                                                    setIsBreed(false);
                                                                }}
                                                                onBlur={()=>{
                                                                    if (!values.breed.length) {
                                                                        setFieldValue("breed", "");
                                                                        setIsBreed(true);
                                                                    }
                                                                }}
                                                                disabled={disabled}
                                                                renderInput={(params) => <>
                                                                    <RTextField {...params}
                                                                        error={(isSubmit || isBreed) && !values.breed}
                                                                        margin="dense"
                                                                        variant="outlined"
                                                                        label="Breed"
                                                                    />
                                                                    {(!values.breed && (isBreed || isSubmit)) && <Typography
                                                                        className={classes.formError}>Required</Typography>}
                                                                </>}
                                                            />
                                                            }
                                                            {animalType === "AMPHIBIAN" &&
                                                            <Autocomplete
                                                                fullWidth
                                                                id="breed"
                                                                aria-labelledby="breed"
                                                                options={amphibians}
                                                                disableClearable
                                                                getOptionLabel={(option) => option}
                                                                value={values.breed}
                                                                onChange={(event, value) => {
                                                                    setFieldValue("breed", value);
                                                                    setIsBreed(false);
                                                                }}
                                                                onBlur={()=>{
                                                                    if (!values.breed.length) {
                                                                        setFieldValue("breed", "");
                                                                        setIsBreed(true);
                                                                    }
                                                                }}
                                                                disabled={disabled}
                                                                renderInput={(params) =>
                                                                    <>
                                                                        <RTextField {...params}
                                                                            error={(isSubmit || isBreed) && !values.breed}
                                                                            margin="dense"
                                                                            variant="outlined"
                                                                            label="Breed"
                                                                        />
                                                                        {(!values.breed && (isBreed || isSubmit)) && <Typography
                                                                            className={classes.formError}>Required</Typography>}
                                                                    </>}
                                                            />
                                                            }
                                                            {animalType === "AQUATIC" &&
                                                            <Autocomplete
                                                                fullWidth
                                                                id="breed"
                                                                aria-labelledby="breed"
                                                                options={aquatic}
                                                                disableClearable
                                                                getOptionLabel={(option) => option}
                                                                value={values.breed}
                                                                onChange={(event, value) => {
                                                                    setFieldValue("breed", value);
                                                                    setIsBreed(false);
                                                                }}
                                                                onBlur={()=>{
                                                                    if (!values.breed.length) {
                                                                        setFieldValue("breed", "");
                                                                        setIsBreed(true);
                                                                    }
                                                                }}
                                                                disabled={disabled}
                                                                renderInput={(params) =>
                                                                    <>
                                                                        <RTextField {...params}
                                                                            error={(isSubmit || isBreed) && !values.breed}
                                                                            margin="dense"
                                                                            variant="outlined"
                                                                            label="Breed"
                                                                        />
                                                                        {(!values.breed && (isBreed || isSubmit)) && <Typography
                                                                            className={classes.formError}>Required</Typography>}
                                                                    </>}
                                                            />
                                                            }
                                                            {animalType === "MUSTELIDAE" &&
                                                            <Autocomplete
                                                                fullWidth
                                                                id="breed"
                                                                aria-labelledby="breed"
                                                                options={mustelidae}
                                                                disableClearable
                                                                getOptionLabel={(option) => option}
                                                                value={values.breed}
                                                                onChange={(event, value) => {
                                                                    setFieldValue("breed", value);
                                                                    setIsBreed(false);
                                                                }}
                                                                onBlur={()=>{
                                                                    if (!values.breed.length) {
                                                                        setFieldValue("breed", "");
                                                                        setIsBreed(true);
                                                                    }
                                                                }}
                                                                disabled={disabled}
                                                                renderInput={(params) =>
                                                                    <>
                                                                        <RTextField {...params}
                                                                            error={(isSubmit || isBreed) && !values.breed}
                                                                            margin="dense"
                                                                            variant="outlined"
                                                                            label="Breed"
                                                                        />
                                                                        {(!values.breed && (isBreed || isSubmit)) && <Typography
                                                                            className={classes.formError}>Required</Typography>}
                                                                    </>}
                                                            />
                                                            }
                                                            {(animalType === "Other" || animalType === 'CHICKEN') &&
                                                            <Field
                                                                fullWidth
                                                                component={TextField}
                                                                id="outlined-basic"
                                                                variant="outlined"
                                                                name="breed"
                                                                label="Breed"
                                                                aria-labelledby="breed"
                                                                margin="dense"
                                                                value={values.breed}
                                                                disabled={disabled}
                                                                onChange={(e) => {
                                                                    setFieldValue("breed", e.target.value);
                                                                }}
                                                            />}
                                                        </Grid>
                                                    </Grid>
                                                    <Grid item xs={12} container alignItems="center">
                                                        <Grid item container alignItems="center" xs={4}>
                                                            <Typography variant="body2">
                                                                Date of Birth
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={8}>
                                                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                                <DatePicker
                                                                    name="dateOfBirth"
                                                                    id="dateOfBirth"
                                                                    label="Date of Birth"
                                                                    aria-labelledby="date of birth"
                                                                    autoOk
                                                                    error={(isSubmit || isBirthday) && !values.dateOfBirth}
                                                                    inputVariant="outlined"
                                                                    openTo="year"
                                                                    views={["year", "month", "date"]}
                                                                    value={values.dateOfBirth ? moment(values.dateOfBirth, "YYYY-MM-DD") : null}
                                                                    fullWidth={true}
                                                                    size="small"
                                                                    format="MM/dd/yyyy"
                                                                    disableFuture={true}
                                                                    maxDate={new Date()}
                                                                    minDate={new Date("1990-01-01")}
                                                                    onChange={(val) => {
                                                                        setFieldValue(
                                                                            "dateOfBirth",
                                                                            val ? moment(val).format("YYYY-MM-DD") : null
                                                                        );
                                                                        setIsBirthday(!val);
                                                                    }}
                                                                    onBlur={() => {
                                                                        if (!values.dateOfBirth?.length) {
                                                                            setFieldValue("dateOfBirth", null);
                                                                            setIsBirthday(true);
                                                                        }
                                                                    }}
                                                                    disabled={disabled}
                                                                />
                                                            </MuiPickersUtilsProvider>
                                                            {(!values.dateOfBirth && (isBirthday || isSubmit)) && <Typography
                                                                className={classes.formError}>Required</Typography>}
                                                        </Grid>
                                                    </Grid>
                                                    <Grid item xs={12} container alignItems="center">
                                                        <Grid item xs={4}>
                                                            <Typography variant="body2">
                                                                Primary Color
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={8}>
                                                            {(animalType === "Dog" || animalType === "Cat") &&
                                                            <Autocomplete
                                                                fullWidth
                                                                id="primaryColor"
                                                                aria-labelledby="primary color"
                                                                options={dogsAndCatsColors}
                                                                disableClearable
                                                                getOptionLabel={(option) => option}
                                                                value={values.primaryColor}
                                                                onChange={(event, value) => {
                                                                    setFieldValue("primaryColor", value);
                                                                    setIsPrimaryColor(false);
                                                                }}
                                                                onBlur={()=>{
                                                                    if (!values.primaryColor?.length) {
                                                                        setFieldValue("primaryColor", "");
                                                                        setIsPrimaryColor(true);
                                                                    }
                                                                }}
                                                                disabled={disabled}
                                                                renderInput={(params) => <>
                                                                    <RTextField {...params}
                                                                        error={(isSubmit || isPrimaryColor) && !values.primaryColor}
                                                                        margin="dense"
                                                                        variant="outlined"
                                                                        label="Primary Color"
                                                                        placeholder = {disabled ? "None selected" : ""}
                                                                        value= {values.primaryColor?.length === 0 ? "None selected" : values.primaryColor}
                                                                    />
                                                                    {(!values.primaryColor && (isPrimaryColor || isSubmit)) && <Typography
                                                                        className={classes.formError}>Required</Typography>}
                                                                </>}
                                                            />
                                                            }
                                                            {(animalType !== "Cat" && animalType !== "Dog") &&
                                                            <Autocomplete
                                                                fullWidth
                                                                id="primaryColor"
                                                                aria-labelledby="primary color"
                                                                options={generalColors}
                                                                disableClearable
                                                                getOptionLabel={(option) => option}
                                                                value={values.primaryColor}
                                                                onChange={(event, value) => {
                                                                    setFieldValue("primaryColor", value);
                                                                    setIsPrimaryColor(false);
                                                                }}
                                                                onBlur={()=>{
                                                                    if (!values.primaryColor?.length) {
                                                                        setFieldValue("primaryColor", "");
                                                                        setIsPrimaryColor(true);
                                                                    }
                                                                }}
                                                                disabled={disabled}
                                                                renderInput={(params) => <>
                                                                    <RTextField {...params}
                                                                        error={(isSubmit || isPrimaryColor) && !values.primaryColor}
                                                                        margin="dense"
                                                                        variant="outlined"
                                                                        label="Primary Color"
                                                                        value= {values.primaryColor?.length === 0 ? "None selected" : values.primaryColor}
                                                                    />
                                                                    {(!values.primaryColor && (isPrimaryColor || isSubmit)) && <Typography
                                                                        className={classes.formError}>Required</Typography>}
                                                                </>}
                                                            />
                                                            }
                                                        </Grid>
                                                    </Grid>
                                                    <Grid item xs={12} container alignItems="center">
                                                        <Grid item xs={4}>
                                                            <Typography variant="body2">
                                                                Secondary Color
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={8}>
                                                            {(animalType === "Dog" || animalType === "Cat") &&
                                                            <Autocomplete
                                                                fullWidth
                                                                id="secondaryColor"
                                                                aria-labelledby="secondary color"
                                                                options={dogsAndCatsColors}
                                                                getOptionLabel={(option) => option}
                                                                value={values.secondaryColor}
                                                                onChange={(event, value) => {
                                                                    setFieldValue("secondaryColor", value);
                                                                }}
                                                                disabled={disabled}
                                                                renderInput={(params) => <RTextField {...params}
                                                                    margin="dense"
                                                                    label="Secondary Color"
                                                                    value= {values.secondaryColor?.length === 0 ? "None selected" : values.secondaryColor}
                                                                    variant="outlined"/>}
                                                            />
                                                            }
                                                            {(animalType !== "Cat" && animalType !== "Dog") &&
                                                            <Autocomplete
                                                                fullWidth
                                                                id="secondaryColor"
                                                                aria-labelledby="secondary color"
                                                                options={generalColors}
                                                                getOptionLabel={(option) => option}
                                                                value={values.secondaryColor}
                                                                onChange={(event, value) => {
                                                                    setFieldValue("secondaryColor", value);
                                                                }}
                                                                disabled={disabled}
                                                                renderInput={(params) => <RTextField {...params}
                                                                    margin="dense"
                                                                    label="Secondary Color"
                                                                    value= {values.secondaryColor?.length === 0 ? "None selected" : values.secondaryColor}
                                                                    variant="outlined"/>}
                                                            />
                                                            }
                                                        </Grid>
                                                    </Grid>
                                                    <Grid item container alignItems="center" xs={12}>
                                                        <Grid item xs={4}>
                                                            <Typography variant="body2">
                                                                Weight
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={8} container direction="row" alignItems="center">
                                                            <Grid item xs={9}>
                                                                <Field
                                                                    component={TextField}
                                                                    onChange={handleChange}
                                                                    value={values.weight}
                                                                    name="weight"
                                                                    label="Weight"
                                                                    aria-labelledby="weight"
                                                                    id="weight"
                                                                    inputProps={{min: 0, step: 0.1}}
                                                                    type="number"
                                                                    variant="outlined"
                                                                    color="secondary"
                                                                    size="small"
                                                                    margin="dense"
                                                                    disabled={disabled}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={3} container justify="center">
                                                                <Typography variant="body2">
                                                                    lbs
                                                                </Typography>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid item container alignItems="center" xs={12}>
                                                        <Grid item xs={4}>
                                                            <Typography variant="body2">
                                                                Sex
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={8}>
                                                            <Field component={RadioGroup} id="sex" name="sex" aria-labelledby="sex" row>
                                                                <FormControlLabel disabled={disabled} value="MALE"
                                                                    control={<Radio/>} label="Male"/>
                                                                <FormControlLabel disabled={disabled} value="FEMALE"
                                                                    control={<Radio/>} label="Female"/>
                                                            </Field>
                                                        </Grid>
                                                        <ErrorMessage name="sex">
                                                            {msg => <Typography
                                                                className={classes.formError}>{msg}</Typography>}
                                                        </ErrorMessage>
                                                    </Grid>
                                                    <Grid item container alignItems="center" xs={12}>
                                                        <Grid item xs={4}>
                                                            <Typography variant="body2">
                                                                {values.sex === "FEMALE" ? "Spayed" : "Neutered"}
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={8}>
                                                            <Field component={RadioGroup} id="neuteredSpayed" aria-labelledby="neuteredSpayed" name="neuteredSpayed"
                                                                onChange={handleChange} row>
                                                                <FormControlLabel disabled={disabled} value="true"
                                                                    control={<Radio/>} label="Yes"/>
                                                                <FormControlLabel disabled={disabled} value="false"
                                                                    control={<Radio/>} label="No"/>
                                                            </Field>
                                                        </Grid>
                                                        <ErrorMessage name="neuteredSpayed">
                                                            {msg => <Typography
                                                                className={classes.formError}>{msg}</Typography>}
                                                        </ErrorMessage>
                                                    </Grid>
                                                    <Grid item xs={12} container justify="space-between"
                                                        alignItems="center">
                                                        <Grid item xs={4}>
                                                            <Typography variant="body2" style={{marginRight: "50px"}}>
                                                                Diet <span
                                                                    style={{fontWeight: 400, fontSize: "12px"}}>{disabled ? "" : "(Select all that apply)"}</span>
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={8}>
                                                            <Autocomplete
                                                                fullWidth
                                                                multiple
                                                                aria-labelledby="diets"
                                                                id="diets"
                                                                options={diets}
                                                                getOptionLabel={(option) => option}
                                                                renderInput={(params) => <RTextField {...params}
                                                                label="Diet"
                                                                    value= {values.diet?.length === 0 ? "None selected" : ""}
                                                                    variant="outlined"/>}
                                                                value={values.diet}
                                                                size="small"
                                                                disabled={disabled}
                                                                onChange={(event, value) => setFieldValue("diet", value)}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                    {animalType === "Cat" &&
                                                    <>
                                                        <Grid item container alignItems="center" xs={12}>
                                                            <Grid item xs={4}>
                                                                <Typography variant="body2">
                                                                    Environment
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item xs={8}>
                                                                <Field component={RadioGroup} name="environment" aria-labelledby="environment" id="environment"
                                                                    onChange={handleChange} row>
                                                                    <FormControlLabel disabled={disabled}
                                                                        value="Indoor only"
                                                                        control={<Radio/>}
                                                                        label="Indoor only"/>
                                                                    <FormControlLabel disabled={disabled}
                                                                        value="Indoor-outdoor"
                                                                        control={<Radio/>}
                                                                        label="Indoor-outdoor"/>
                                                                </Field>
                                                            </Grid>
                                                        </Grid>
                                                        <Grid item xs={12} container justify="space-between"
                                                            alignItems="center">
                                                            <Grid item xs={4}>
                                                                <Typography variant="body2">
                                                                    Number of Litter boxes
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item xs={8}>
                                                                <Field
                                                                    component={TextField}
                                                                    aria-labelledby="number of litter boxes"
                                                                    id="numLitterBoxes"
                                                                    label="Number of Litter boxes"
                                                                    name="numLitterBoxes"
                                                                    value={values.numLitterBoxes}
                                                                    variant="outlined"
                                                                    color="secondary"
                                                                    type="number"
                                                                    margin="dense"
                                                                    size="small"
                                                                    fullWidth
                                                                    onChange={handleChange}
                                                                    placeholder=""
                                                                    disabled={disabled}
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </>
                                                    }
                                                    {user.role === "ADMIN" &&
                                                        <>
                                                            <Grid item xs={12} container justify="space-between"
                                                                alignItems="center">
                                                                <Grid item xs={4}>
                                                                    <Typography variant="body2">
                                                                        Pharmacy Name
                                                                    </Typography>
                                                                </Grid>
                                                                <Grid item xs={8}>
                                                                    <Field
                                                                        component={TextField}
                                                                        label="Pharmacy Name"
                                                                        name="pharmacyName"
                                                                        aria-labelledby="pharmacy name"
                                                                        id="pharmacyName"
                                                                        value={values.pharmacyName}
                                                                        variant="outlined"
                                                                        color="secondary"
                                                                        margin="dense"
                                                                        size="small"
                                                                        fullWidth
                                                                        onChange={handleChange}
                                                                        placeholder=""
                                                                        disabled={disabled}
                                                                    />
                                                                </Grid>
                                                            </Grid>
                                                            <Grid item xs={12} container justify="space-between"
                                                                alignItems="center">
                                                                <Grid item xs={4}>
                                                                    <Typography variant="body2">
                                                                        Pharmacy Phone Number
                                                                    </Typography>
                                                                </Grid>
                                                                <Grid item xs={8}>
                                                                    <Field
                                                                        component={TextField}
                                                                        name="pharmacyPhone"
                                                                        label="Pharmacy Phone Number"
                                                                        aria-labelledby="pharmacy phone"
                                                                        id="pharmacyPhone"
                                                                        value={values.pharmacyPhone}
                                                                        variant="outlined"
                                                                        color="secondary"
                                                                        margin="dense"
                                                                        size="small"
                                                                        fullWidth
                                                                        onChange={handleChange}
                                                                        placeholder=""
                                                                        disabled={disabled}
                                                                    />
                                                                </Grid>
                                                            </Grid>
                                                        </>}
                                                    {
                                                        disabled &&
                                                        <>
                                                            <Grid item container alignItems="center" xs={12}>
                                                                <Grid item xs={4} sm={2}>
                                                                    <Typography variant="body2">
                                                                        Allergies
                                                                    </Typography>
                                                                </Grid>
                                                                <Grid item xs={12} sm={10}>
                                                                    <RTextField
                                                                        multiline
                                                                        fullWidth
                                                                        value={allergies || "No known allergies"}
                                                                        variant="outlined"
                                                                        aria-labelledby="allergies"
                                                                        id="allergies"
                                                                        name="allergies"
                                                                        label="Allergies"
                                                                        disabled
                                                                    />
                                                                </Grid>
                                                            </Grid>
                                                            <Grid item container alignItems="center" xs={12}>
                                                                <Grid item xs={4} sm={2}>
                                                                    <Typography variant="body2">
                                                                        Chronic Illnesses
                                                                    </Typography>
                                                                </Grid>
                                                                <Grid item xs={12} sm={10}>
                                                                    <RTextField
                                                                        multiline
                                                                        fullWidth
                                                                        value={chronicIllnesses || "No issues recorded"}
                                                                        variant="outlined"
                                                                        id="illnesses"
                                                                        aria-labelledby="illnesses"
                                                                        name="illnesses"
                                                                        label="Chronic Illnesses"
                                                                        disabled
                                                                    />
                                                                </Grid>
                                                            </Grid>
                                                            {user.role !== "OWNER" &&
                                                            <Grid item container alignItems="center" xs={12}>
                                                                <Grid item xs={4} sm={4}>
                                                                    <Typography variant="body2">
                                                                        Medications
                                                                    </Typography>
                                                                </Grid>
                                                                <Grid item xs={12} sm={8}>
                                                                    <RTextField
                                                                        multiline
                                                                        fullWidth
                                                                        value={values.medications?.length === 0 ? "No medications provided" : values.medications.map((medication) => {
                                                                            return medication.name;
                                                                        }).join(", ")}
                                                                        variant="outlined"
                                                                        id="medications"
                                                                        aria-labelledby="medications"
                                                                        name="medications"
                                                                        label="Medications"
                                                                        disabled
                                                                    />
                                                                </Grid>
                                                            </Grid>
                                                            }
                                                        </>
                                                    }
                                                </Grid>
                                            </Grid>
                                        </Box>
                                        {!disabled ?
                                            <Grid container justify="flex-start" spacing={2}>
                                                <Grid item xs={12} sm={3}>
                                                    <Button
                                                        fullWidth
                                                        color="primary"
                                                        variant="contained"
                                                        type="submit"
                                                        data-testid="submitButton"
                                                        onClick={()=> setIsSubmit(true)}
                                                    >
                                                        Save
                                                    </Button>
                                                    {/*{errors.name && <div id="feedback">{errors.name}</div>}*/}
                                                </Grid>
                                                <Grid item xs={12} sm={3}>
                                                    <Button
                                                        type="button"
                                                        fullWidth
                                                        variant="contained"
                                                        color="primary"
                                                        onClick={() => history.goBack()}
                                                    >
                                                        Cancel
                                                    </Button>
                                                </Grid>
                                            </Grid> : null}
                                    </>
                                    :
                                    <Box display="flex" justifyContent="center" alignItems="center" height="300px">
                                        <CircularProgress/>
                                    </Box>
                            }
                            {
                                uploadPhotoURL &&
                                <UploadPhoto
                                    onClose={() => {
                                        setUploadPhotoModalVisibility(false);
                                    }}
                                    isOpen={uploadPhotoModalVisibility}
                                    imageUploadURL={uploadPhotoURL}
                                    onLoad={(val) => {
                                        dispatch(getPetURLUploadImage(pet.id))
                                            .then((res) => {
                                                setLinkToImage(res.downloadUrl);
                                                setUploadPhotoUrl(res.uploadUrl);
                                            });
                                        setUploadPhotoModalVisibility(false);
                                    }}
                                />
                            }
                        </Form>
                    );
                }
            }
        </Formik>
    );
};
